import React from 'react';
import {BuilderPlanForm} from '../CreateBuilder/BuilderSourceDestination/BuilderPlanForm';
import {BuilderShellPlan} from '../BuilderSetUpNew/BuilderShellPlan';
import {TransferShellPlanData} from './BuilderTransferHelpers';

interface BuilderTransferShellPlanFormProps {
  shellPlan: TransferShellPlanData;
  index: number;
  isSelected: boolean;
  handleChange: (id: string) => void;
}

export const BuilderTransferShellPlanForm: React.FC<
  BuilderTransferShellPlanFormProps
> = ({shellPlan, index, isSelected, handleChange}) => {
  return (
    <BuilderPlanForm
      mode="multiple"
      id={shellPlan.id}
      reccId={null}
      summary={`New Source Plan #${index + 1} ${
        shellPlan.accountNumber ? `(${shellPlan.accountNumber})` : ''
      }`}
      details={
        <BuilderShellPlan
          key={shellPlan.id}
          id={shellPlan.id}
          formikShellPlanKey={`transfer.transferSources.${shellPlan.id}`}
        />
      }
      sameReview
      isSelected={isSelected}
      isSubplan={false}
      handleChange={handleChange}
    />
  );
};
